import { webStorage } from 'sidecar-utility-library'

import { isActionRelevant } from './utils'

/** Saves the token to webStorage */

//TODO This isn't what this PR is about, but I don't think VALIDATE_ACCOUNT api calls are used anywhere, and this and other action triggers with VALIDATE_ACCOUNT can probably be removed.
export default () => next => action => {
  if (!isActionRelevant(action, /(VALIDATE_ACCOUNT)_SUCCESS/))
    return next(action)

  const { payload: { registeredAlready } = {} } = action

  if (!registeredAlready) {
    webStorage.setItem('aud', action.payload.accountUuid)
    webStorage.setItem('token', action.payload.token)
  }

  return next(action)
}
